import React from 'react'
import { H1, HEADING_TYPES } from '../Heading/index'

/**
 * Displays a set of perks with icons and text from staticText.
 *
 * @param {Map} staticText - Text content for perk titles and descriptions
 * @returns {JSX.Element} Perks section
 */
function SharePagePerks (props) {
  const { staticText } = props

  return (
    <div className="share-page__perks">
      <div className="share-page__perks-header">
        <H1 as={HEADING_TYPES.H2} className="share-page__perks-title share-page__title">
          {staticText.get('perksTitle')}
        </H1>
      </div>
      <div className="share-page__perks-container">
        <div className="share-page__perks-background-line"></div>
        <div className="share-page__perks-item-container share-page__perks-item-container--left">
          <div className="share-page__perks-item">
            <div className="share-page__perks-item-icon share-page__perks-item-icon--ad-free"></div>
            <p className="share-page__perks-item-title">{staticText.get('valueProp1Title')}</p>
            <p className="share-page__perks-item-text">{staticText.get('valueProp1Text')}</p>
          </div>
          <div className="share-page__perks-item">
            <div className="share-page__perks-item-icon share-page__perks-item-icon--watch-anywhere"></div>
            <p className="share-page__perks-item-title">{staticText.get('valueProp2Title')}</p>
            <p className="share-page__perks-item-text">{staticText.get('valueProp2Text')}</p>
          </div>
        </div>
        <div className="share-page__perks-item-container share-page__perks-item-container--right">
          <div className="share-page__perks-item">
            <div className="share-page__perks-item-icon share-page__perks-item-icon--award-winning"></div>
            <p className="share-page__perks-item-title">{staticText.get('valueProp3Title')}</p>
            <p className="share-page__perks-item-text">{staticText.get('valueProp3Text')}</p>
          </div>
          <div className="share-page__perks-item">
            <div className="share-page__perks-item-icon share-page__perks-item-icon--community"></div>
            <p className="share-page__perks-item-title">{staticText.get('valueProp4Title')}</p>
            <p className="share-page__perks-item-text">{staticText.get('valueProp4Text')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SharePagePerks
